import { CheckCircleIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import { toast } from "react-toastify";
import Button from "components/atoms/buttons/Button";
import { useBrandContext } from "components/context/BrandContext";
import { useLoaderContext } from "components/context/LoaderContext";
import { get } from "utils/request";
import { TOAST_CONFIG } from "../../../../../constants";

function ConnectStripe({ onClose }: { onClose: () => void }) {
  const { setLoading } = useLoaderContext();
  const { brandDetails, brandId } = useBrandContext();
  return (
    <div className="flex flex-col">
      <div className="w-[90%]">
        <p className="mt-4 font-medium opacity-90">
          Seems like you are trying to create a Release and your stripe account is not yet linked!
        </p>
        <p className="mt-1 opacity-70">
          To begin selling your valuable magnets and earning from each sale, you need to connect your{" "}
          <span className="font-black underline">US Stripe account</span>. Stripe is a well established, secure and
          trusted payment gateway that ensures smooth transactions between you and your customers.
        </p>
        <p className="mt-4 font-bold underline opacity-90">Why Connect Your Stripe Account?</p>
        <p className="mt-1 opacity-70">
          Connecting your Stripe account enables you to receive your earnings seamlessly whenever your Magnet is sold.
          It&apos;s easy, secure, and convenient.
        </p>
      </div>
      <p className="-mb-1.5 ml-auto mt-6 flex gap-3">
        <Button onClick={onClose} variant="whiteOutline" text="CANCEL" additionalClasses="text-xs" />
        <Button
          icon={brandDetails.is_stripe_connected && <CheckCircleIcon className="h-5 w-5" />}
          text={brandDetails.is_stripe_connected ? "STRIPE CONNECTED" : "CONNECT STRIPE"}
          variant="magnetiqSolid"
          disabled={brandDetails.is_stripe_connected}
          additionalClasses={clsx(
            "!text-base !px-4 !py-2 !text-white",
            brandDetails.is_stripe_connected ? "!bg-lime-700 disabled:!opacity-90" : "!bg-[#635bff]",
          )}
          onClick={() => {
            setLoading(true, "Please Wait! Taking you to stripe....");
            get(
              `/api/v1/payments/stripe/connect?brand_id=${brandId}&redirect_to=${encodeURIComponent(
                window.location.href,
              )}`,
              {
                processData: ({ data }) => {
                  window.location.assign(data.redirect_url);
                },
                processError: () => {
                  setLoading(false);
                  toast.error("Unexpected Error, Please try Again!", TOAST_CONFIG);
                },
              },
            );
          }}
        />
      </p>
    </div>
  );
}
export default ConnectStripe;
